/* MIXINS */
import roleKeysConst from '@mixins/const/roleKeysConst';
import roleTypesConst from '@mixins/const/roleTypesConst';

/* UTILITAIRES POUR GÉRER LES INFORMATIONS D'UN SALARIÉ DANS LES FORMULAIRES */
export default {
  mixins: [roleKeysConst, roleTypesConst],
  data() {
    return {
      employee: {},
    };
  },
  computed: {
    isRoleTypeGas() {
      return this.employee.roleType === 'GAS';
    },
    isRoleTypeGav() {
      return this.employee.roleType === 'GAV';
    },
    buildRoleKeys() {
      if (this.isRoleTypeGav) return this.roleKeysForGav;
      if (this.isRoleTypeGas) return this.roleKeysForGas;
      return null;
    },
  },
};
